
import React from 'react';
import CtaSection from '@/components/CtaSection';
import AIConsultantChat from '@/components/AIConsultantChat';

const AIConsultant = () => {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <main className="flex-1">
        <section className="py-20 px-6 md:px-10">
          <div className="container mx-auto max-w-6xl">
            <div className="mb-16 text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                AI <span className="text-highlight">Business Consultant</span>
              </h1>
              <p className="text-lg md:text-xl max-w-3xl mx-auto text-muted-foreground">
                Not sure what you need? Our AI consultant will analyze your business challenges 
                and suggest the perfect AI-powered solution—all in under 5 minutes.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-10 items-start">
              {/* Chat Interface Section */}
              <div className="rounded-2xl border border-border p-8 bg-card h-full">
                <h2 className="text-2xl font-semibold mb-6">Chat with our AI Business Consultant</h2>
                <AIConsultantChat fullPage={true} />
              </div>

              {/* Benefits Section */}
              <div className="space-y-8">
                <div className="rounded-2xl border border-border p-8 bg-card">
                  <h3 className="text-xl font-semibold mb-4">Why Use Our AI Consultant?</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <div className="bg-primary/10 p-2 rounded-full text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                      </div>
                      <div>
                        <p className="font-medium">Get instant insights</p>
                        <p className="text-sm text-muted-foreground">No waiting for human responses or quotes</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="bg-primary/10 p-2 rounded-full text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-lightbulb"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>
                      </div>
                      <div>
                        <p className="font-medium">Discover AI solutions</p>
                        <p className="text-sm text-muted-foreground">Learn about cutting-edge AI tools for your business</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="bg-primary/10 p-2 rounded-full text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-piggy-bank"><path d="M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z"/><path d="M2 9v1c0 1.1.9 2 2 2h1"/><path d="M16 11h0"/></svg>
                      </div>
                      <div>
                        <p className="font-medium">Save time and money</p>
                        <p className="text-sm text-muted-foreground">Receive tailored solutions under $5K</p>
                      </div>
                    </li>
                  </ul>
                </div>
                
                <div className="rounded-2xl border border-border p-8 bg-card">
                  <h3 className="text-xl font-semibold mb-4">Client Success Stories</h3>
                  <div className="space-y-6">
                    <div className="space-y-2">
                      <p className="italic">"The AI consultant recommended a custom CRM that saved us 15 hours a week in admin work!"</p>
                      <p className="text-sm text-muted-foreground">— Sarah T., E-commerce Store Owner</p>
                    </div>
                    <div className="space-y-2">
                      <p className="italic">"I had no idea what I needed, but within minutes, the AI suggested the perfect booking system for my salon."</p>
                      <p className="text-sm text-muted-foreground">— Michael R., Salon Owner</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <CtaSection 
          title="Ready to Transform Your"
          highlightText="Business with AI?"
          description="Book a free consultation with our human experts to discuss your custom AI solution in detail."
          primaryButtonText="Book a Free Consultation"
          primaryButtonLink="/booking"
        />
      </main>
    </div>
  );
};

export default AIConsultant;
